import React, { useEffect } from 'react'
import Layout from '../component/Layout/Layout'
import './blog.css'

import { useBlogDetailsAPI } from '../hooks/useAllCategoryData';
import { useParams } from 'react-router-dom';
import { dateInMDY } from '../Helper'
import parse from "html-react-parser";
import { useState } from 'react';

export default function BlogDetail() {
    const { slug } = useParams();
    const { isLoading, error, data } = useBlogDetailsAPI(slug);
    const [countryCode, setCountryCode] = useState("");
    useEffect(() => {
        const countryData = JSON.parse(sessionStorage.getItem("country_data"));
        if (countryData?.code) {
            setCountryCode(countryData.code);
        }
    }, []);

    if (error) return <div>{error.message}</div>;
    // console.log('blogData',data)
    const rawDescription = (countryCode === "AED" && data?.posts?.post_content_dubai)
        ? data?.posts?.post_content_dubai
        : data?.posts?.post_content;

    const safeDescription = typeof rawDescription === "string" ? parse(rawDescription) : null;

    return (
        <Layout title={`${data?.posts?.post_title ? data.posts.post_title : data?.posts.title} | Chaashni by Maansi & Ketan`} /* title={data?.page.meta_title} description={data?.page.meta_description} keywords={data?.page.meta_keyword}  */ >
            <div className="site-content-wrap static-page blog-list blog-detail">
                <div className="container">
                    <div className="row">
                        <div className='col-md-12'>
                            {isLoading && (
                                <div className='loading-div'><span>Loading...</span></div>
                            )}
                            {!isLoading && (
                                <div className='blogbox'>
                                    <div className='imgbox'>
                                        <h1 className='blog-title'>{data?.posts?.post_title}</h1>
                                        <img src={`${process.env.REACT_APP_API_ROOT}/storage/app/public/blog/${JSON.parse(data?.posts?.images)[0]}`} alt='' />
                                    </div>
                                    <div className='blog-content'>
                                        {data?.posts &&
                                            <div className='author'><span className='author-date'><i className="fa-solid fa-calendar-days"></i>
                                                {dateInMDY(data?.posts?.created_at)}
                                            </span></div>
                                        }
                                        {safeDescription}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}